(function () {
  'use strict';

  /* global $ */
  class HeaderCtrl {

    constructor(Uos, $timeout) {
      this.sistema = 'core-permissoes';
      this.authserver = '/usuario';
      this.alertasserver = '/alertas/resources';

      this.uo = {
        id: -1,
        nome: 'Carregando UOs...'
      };
      Uos.getFilhas().then(data => angular.extend(this.uo, data.plain()));
      $timeout(() => {
        $.AdminLTE.tree('.sidebar');
      });

      this.menu = [
        {label: 'core-permissoes.organizacao.menuLabel', icon: 'fa-building-o',
          roles: [
            'UO_VISUALIZAR',
            'USUARIO_VISUALIZAR',
            'COMPARTILHAMENTOS_VISUALIZAR',
            'VEICULO_PERMISSAO_VISUALIZAR',
            'ADMIN_VELTEC'
          ],
          submenu: [
            {label: 'core-permissoes.organizacao.uos.menuLabel', state: 'root.uos', role: 'UO_VISUALIZAR'},
            {label: 'core-permissoes.organizacao.usuarios.menuLabel', state: 'root.usuarios', role: 'USUARIO_VISUALIZAR'},
            {label: 'core-permissoes.organizacao.compartilhamentos.menuLabel', state: 'root.compartilhamentos', role: 'COMPARTILHAMENTOS_VISUALIZAR'},
            {label: 'core-permissoes.organizacao.transferenciaDeVeiculos.menuLabel', state: 'root.veiculos', role: 'VEICULO_PERMISSAO_VISUALIZAR'},
            {label: 'core-permissoes.organizacao.abonoDeImprocedencias.menuLabel', state: 'root.expurgo', role: 'ABONO_VISUALIZAR'}
          ]
        },
        {label: 'core-permissoes.configuracoes.menuLabel', icon: 'fa-gears',
          roles: [
            'ADMIN_VELTEC',
            'PERFIL_USUARIO_VISUALIZAR'
          ],
          submenu: [
            {label: 'core-permissoes.configuracoes.perfisDeUsuario.menuLabel', state: 'root.perfis', role: 'PERFIL_USUARIO_VISUALIZAR'}
          ]
        }
      ];

      this.menu[0].submenu.push({label: 'core-permissoes.organizacao.camadaValor.menuLabel', state: 'root.camadaValor', role: 'CAMADA_VALOR_VISUALIZAR'});
    }
  }

  /**
   * @ngdoc object
   * @name corePermissoes.controller:HeaderCtrl
   *
   * @description
   *
   */
  angular
    .module('headerModule', ['ui.router', 'uoModule', 'enumModule'])
    .controller('HeaderCtrl', HeaderCtrl);
}());
